<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="900">
  <kendo-dialog-titlebar>
    <h3>{{ (isNew ? 'ADD-ORGANIZATION' : 'EDIT-ORGANIZATION') | translate }}</h3>
  </kendo-dialog-titlebar>
  <form novalidate [formGroup]="editForm">
    <kendo-tabstrip #tabstrip>
      <kendo-tabstrip-tab title="{{ 'ORGANIZATION' | translate }}" [selected]="true">
        <ng-template kendoTabContent>
          <div class="k-form tab-organization">
            <div class="row">
              <div class="col-12">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'NAME' | translate}} *
                  </span>
                  <input id="name" kendoTextBox formControlName="name" maxlength="100" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="name.hasError('required') && name.touched">
                    {{'REQUIRED-NAME' | translate}}
                  </div>
                  <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="name.hasError('nameExists')">
                    {{'ORGANIZATION-ALREADY-EXISTS' | translate}}
                  </div>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-6" [ngClass]="{'col-6': communityEnabled, 'col-12':!communityEnabled}">
                <label for="organizationType" class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{ 'ORGANIZATION-TYPE' | translate }} *
                  </span>
                  <kendo-combobox class="w-100" formControlName="organizationType" [data]="organizationTypes"
                    [textField]="'displayName'" [valueField]="'id'" [valuePrimitive]="false">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="organizationType.hasError('required') && organizationType.touched">
                    {{'REQUIRED-ORGANIZATION-TYPE' | translate}}
                  </div>
                </label>
              </div>
              <div class="col-6" *ngIf="communityEnabled && !revenueManager">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'REFERRAL-CHANNEL' | translate}}
                  </span>
                  <kendo-combobox id="referralChannelId" class="w-100" formControlName="referralChannelId"
                    [valuePrimitive]="true" [itemDisabled]="channelItemDisabled" [data]="groupedChannels"
                    [textField]="'name'" [valueField]="'id'">
                  </kendo-combobox>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'PARENT-ORGANIZATION' | translate}}
                  </span>
                  <kendo-combobox id="parentOrganization" formControlName="parentOrganization" class="w-100"
                    [valuePrimitive]="false" [itemDisabled]="itemDisabled" [data]="organizations" [textField]="'name'"
                    [valueField]="'id'" (valueChange)="handleOrganizationChange($event)">
                  </kendo-combobox>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label for="comments" class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{ 'COMMENTS' | translate }}
                  </span>
                  <textarea kendoTextArea class="w-100" cols="120" rows="2" formControlName="comments"
                    maxlength="4000"></textarea>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label class="k-text-uppercase dark mr-2 k-form-field" for="submittingOrganization">
                  {{ 'SUBMITTING-ORGANIZATION' | translate }}</label>
                <kendo-switch formControlName="submittingOrganization" onLabel="{{'YES' | translate }}"
                  offLabel="{{'NO' | translate }}">
                </kendo-switch>
              </div>
              <div class="col-4">
                <label class="k-text-uppercase dark mr-2 k-form-field" for="active">
                  {{ 'ENABLED' | translate }}</label>
                <kendo-switch formControlName="active" onLabel="{{'YES' | translate }}"
                  offLabel="{{'NO' | translate }}">
                </kendo-switch>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'ADDRESS' | translate }}">
        <ng-template kendoTabContent>
          <div class="k-form">
            <div class="row">
              <div class="col-8">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'STREET' | translate}}
                  </span>
                  <input id="streetLine" kendoTextBox formControlName="streetLine" class="w-100" /> <i
                    *ngIf="addressAPIEnabled && streetLine.value" class="far fa-search-location pointer ml-3 fa-1_5x"
                    style="color:#3e807c;position:absolute;top:43px;" title="{{'VALIDATE-ADDRESS-ICON' | translate}}"
                    (click)="validateAddress()"></i>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-8">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'ADDRESS-LINE-2' | translate}}
                  </span>
                  <input id="streetLineAdditional" kendoTextBox formControlName="streetLineAdditional" class="w-100" />
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'CITY' | translate}}
                  </span>
                  <input id="city" kendoTextBox formControlName="city" class="w-100" />
                </label>
              </div>
              <div class="col-4">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'COUNTY' | translate}}
                  </span>
                  <input id="county" kendoTextBox formControlName="county" class="w-100" maxlength="150" />
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'STATE' | translate}}
                  </span>
                  <kendo-combobox id="state" class="w-100" formControlName="state" [data]="states"
                    [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="false">
                  </kendo-combobox>
                </label>
              </div>
              <div class="col-4">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'POSTAL-CODE' | translate}}
                  </span>
                  <input id="postalCode" kendoTextBox formControlName="postalCode" class="w-100" />
                </label>
              </div>
              <div class="col-4">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'COUNTRY' | translate}}
                  </span>
                  <kendo-combobox id="country" class="w-100" formControlName="country" [data]="countries"
                    [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="false">
                  </kendo-combobox>
                </label>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'CONTACT' | translate }}">
        <ng-template kendoTabContent>
          <div class="k-form">
            <div class="row">
              <div class="col">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'FIRST-NAME' | translate}}
                  </span>
                  <input id="firstName" kendoTextBox formControlName="firstName" />
                </label>
              </div>
              <div class="col">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'LAST-NAME' | translate}}
                  </span>
                  <input id="lastName" kendoTextBox formControlName="lastName" />
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'TITLE' | translate}}
                  </span>
                  <input id="title" kendoTextBox formControlName="title" />
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    <i class="fas fa-phone fa-fw"></i> {{'BUSINESS-PHONE' | translate}}
                  </span>
                  <kendo-maskedtextbox [mask]="phoneNumberMask" id="homePhoneNumber" formControlName="homePhoneNumber"
                    class="w-100">
                  </kendo-maskedtextbox>
                </label>
              </div>
              <div class="col-3 pl-0">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">{{'PHONE-EXTENSION' | translate}}
                  </span>
                  <input id="homePhoneNumberExtension" kendoTextBox formControlName="homePhoneNumberExtension"
                    class="w-100" maxlength="20" />
                </label>
              </div>
              <div class="col-3">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    <i class="fas fa-mobile-android-alt fa-fw"></i> {{'CELL-PHONE' | translate}}
                  </span>
                  <kendo-maskedtextbox [mask]="phoneNumberMask" id="cellPhoneNumber" formControlName="cellPhoneNumber"
                    class="w-100">
                  </kendo-maskedtextbox>
                </label>
              </div>
              <div class="col-3">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    <i class="fas fa-fax fa-fw"></i> {{'FAX' | translate}}
                  </span>
                  <kendo-maskedtextbox [mask]="phoneNumberMask" id="faxNumber" formControlName="faxNumber"
                    class="w-100">
                  </kendo-maskedtextbox>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    <i class="fas fa-envelope fa-fw"></i> {{'EMAIL' | translate}}&nbsp;
                  </span>
                  <input id="email" kendoTextBox formControlName="email" email />
                  <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="email.invalid && email.touched">
                    {{'WRONG-EMAIL-FORMAT' | translate}}
                  </div>
                </label>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'DEPARTMENTS' | translate }}">
        <ng-template kendoTabContent>
          <div class="tab-departments">
            <div class="p-1">
              <button kendoButton [primary]="true" (click)="addDepartment()" type="button" class="mb-2">
                {{'ADD-DEPARTMENT' | translate}}<i class="far fa-plus"></i>
              </button>
              <div formArrayName="departments" class="container-departments">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th style="width:85%">
                        <label class="k-text-uppercase dark font-weight-normal">{{ 'NAME' | translate }}
                          *</label>
                      </th>
                      <th style="width:10%">
                        <label class="k-text-uppercase dark font-weight-normal">{{ 'ACTIVE' | translate }}</label>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let department of editForm.controls.departments.controls; let i=index"
                      [formGroupName]="i">
                      <td style="width:85%">
                        <input kendoTextBox formControlName="name" class="w-100" maxlength="512" />
                        <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="editForm.controls.departments.controls[i].controls.name.hasError('required') && 
                                    editForm.controls.departments.controls[i].controls.name.touched">
                          {{ 'REQUIRED-NAME' | translate }}
                        </div>
                      </td>
                      <td style="width:10%">
                        <kendo-switch formControlName="active" onLabel="{{'YES' | translate }}"
                          offLabel="{{'NO' | translate }}">
                        </kendo-switch>
                      </td>
                      <td>
                        <a title="{{ 'DELETE' | translate }}"
                          (click)="removeDepartment(i,editForm.controls.departments.controls[i].controls.id.value)">
                          <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'IDENTIFIERS' | translate }}">
        <ng-template kendoTabContent>
          <div class="tab-identifiers">
            <div class="p-1">
              <button kendoButton [primary]="true" (click)="addIdentifier()" type="button" class="mb-2">
                {{'ADD-IDENTIFIER' | translate}}<i class="far fa-plus"></i>
              </button>
              <div formArrayName="identifiers" class="container-identifiers">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th style="width:30%">
                        <label class="k-text-uppercase dark font-weight-normal">{{ 'TYPE' | translate }} *</label>
                      </th>
                      <th style="width:30%">
                        <label class="k-text-uppercase dark font-weight-normal">{{ 'VALUE' | translate }} * </label>
                      </th>
                      <th style="width:35%">
                        <label class="k-text-uppercase dark font-weight-normal">{{ 'ASSIGNING-AUTHORITY' | translate }}
                        </label>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let identifier of editForm.controls.identifiers.controls; let i=index"
                      [formGroupName]="i">
                      <td style="width:30%">
                        <kendo-combobox formControlName="typeDictionary" [data]="types" [textField]="'displayName'"
                          [valueField]="'id'" [valuePrimitive]="false" class="w-100">
                        </kendo-combobox>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="editForm.controls.identifiers.controls[i].controls.typeDictionary.hasError('required') && 
                                                                     editForm.controls.identifiers.controls[i].controls.typeDictionary.touched">
                          {{ 'REQUIRED-IDENTIFIER-TYPE' | translate }}
                        </div>
                      </td>
                      <td style="width:30%">
                        <input id="value" kendoTextBox formControlName="value" class="w-100" maxlength="1024" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="editForm.controls.identifiers.controls[i].controls.value.hasError('required') &&
                                                                                           editForm.controls.identifiers.controls[i].controls.value.touched">
                          {{ 'REQUIRED-IDENTIFIER-VALUE' | translate }}
                        </div>
                      </td>
                      <td style="width:35%">
                        <kendo-combobox formControlName="assigningAuthorityDictionary" [data]="assigningAuthorities"
                          [textField]="'displayName'" [valueField]="'id'" [valuePrimitive]="false" class="w-100">
                        </kendo-combobox>
                      </td>
                      <td>
                        <a title="{{ 'DELETE' | translate }}"
                          (click)="removeIdentifier(i,editForm.controls.identifiers.controls[i].controls.id.value)">
                          <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'PERMISSIONS' | translate }}" *ngIf="!revenueManager">
        <ng-template kendoTabContent>
          <div class="k-form">
            <div class="row">
              <div class="col">
                <label class="k-form-field">
                  {{'PERMISSIONS-ORGANIZATION-COLLECT' | translate}}
                </label>
              </div>
            </div>
            <div class="row">
              <div *ngFor="let consentableDataType of consentableDataTypes">
                <div class="col pr-0">
                  <label class="k-text-uppercase dark k-checkbox-label" for="collect-{{consentableDataType.id}}">
                    {{consentableDataType.displayName}}
                    <input id="collect-{{consentableDataType.id}}" type="checkbox" kendoCheckBox
                      (change)="setConsent(consentableDataType, consentCollects.value, $event)"
                      [checked]="isConsentChecked(consentableDataType.id, consentCollects.value)" />
                  </label>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col">
                <label class="k-form-field">
                  {{'PERMISSIONS-ORGANIZATION-VIEW' | translate}}
                </label>
              </div>
            </div>
            <div class="row">
              <div *ngFor="let consentableDataType of consentableDataTypes">
                <div class="col pr-0">
                  <label class="k-text-uppercase dark k-checkbox-label" for="view-{{consentableDataType.id}}">
                    {{consentableDataType.displayName}}
                    <input id="view-{{consentableDataType.id}}" type="checkbox" kendoCheckBox
                      (change)="setConsent(consentableDataType, consentViews.value, $event)"
                      [checked]="isConsentChecked(consentableDataType.id, consentViews.value)" />
                  </label>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-12">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'ALLOW-ACCESS-TO-TRIBAL-DATA' | translate}}
                  </span>
                  <input type="checkbox" formControlName="allowTribal" kendoCheckBox />
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-9">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'CONSENT-EXPIRATION-POLICY' | translate}}
                  </span>
                </label>
              </div>
              <div class="col-3">
                <kendo-numerictextbox [format]="'n0'" formControlName="consentExpirationMonths" [min]="0">
                </kendo-numerictextbox>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                  *ngIf="consentExpirationMonths.hasError('required') && consentExpirationMonths.touched">
                  {{'REQUIRED-CONSENT-EXPIRATION-POLICY' | translate}}
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
    <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
  </form>
  <kendo-dialog-actions>
    <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty || saving"
      (click)="onSave($event)">{{ 'SAVE' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<app-address-validator #addressValidator (changeAddress)="changeAddress($event)" (save)="saveOrganization()"
  (cancelling)="saving = false;">
</app-address-validator>